import axiosInstance from "../api/api";

const FileService = {
  // Create a new folder
  createFolder: function(name, ownerId, parentId = '') {
    return axiosInstance({
      url: `/api/files/folder`,
      method: "POST",
      params: {
        name,
        ownerId,
        parentId
      }
    });
  },

  // Upload a file
  uploadFile: function(formData) {
    // formData should be an instance of FormData
    return axiosInstance({
      url: `/api/files/upload`,
      method: "POST",
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  // List files in a folder
  listFiles: function(ownerId, parentId = '', page = 0, size = 10) {
    return axiosInstance({
      url: `/api/files/`,
      method: "GET",
      params: {
        ownerId,
        parentId,
        page,
        size
      }
    });
  },

  myFiles: function() {
    return axiosInstance({
      url: `/api/files/`,
      method: "GET",
    });
  },

  shared: function() {
    return axiosInstance({
      url: `/api/files/shared`,
      method: "GET",
    });
  },


  myFilesInFolder: function(parentFolderId) {
    return axiosInstance({
      url: `/api/files/${parentFolderId}`,
      method: "GET",
    });
  },

  // Rename a file or folder
  rename: function(data) {
    return axiosInstance({
      url: `/api/files/rename`,
      method: "PUT",
      params: {
        uniqueId: data.uniqueId,
        newName: data.newName
      }
    });
  },

  // Delete a file or folder
  delete: function(id) {
    return axiosInstance({
      url: `/api/files/${id}`,
      method: "DELETE"
    });
  },

  // Delete a file or folder
  bulkDelete: function(data) {
    return axiosInstance({
      url: `/api/files/bullkDelete`,
      method: "POST",
      data: data
    });
  },

  // Share a file or folder
  share: function(data) {
    return axiosInstance({
      url: `/api/files/share`,
      method: "POST",
      data: data
    });
  },

  // Unshare a file or folder
  unshare: function(data) {
    return axiosInstance({
      url: `/api/files/unshare`,
      method: "POST",
      params: {
        uniqueId: data?.uniqueId,
        email: data?.email
      }
    });
  },

  unshareWithUsers: function(data) {
    return axiosInstance({
      url: `/api/files/bulkUnShare`,
      method: "POST",
      data: data
    });
  },

  folderStructure : function (uniqueId) {
    return axiosInstance({
      url: `/api/files/folderStructure/${uniqueId}`,
      method: "GET"
    });
  },

  // Download a file
  download: function(id) {
    return axiosInstance({
      url: `/api/files/download/${id}`,
      method: "GET",
      responseType: 'blob'
    });
  }
};

export default FileService; 